export default {
    table: {
        id: 'ID',
        association: 'Verband',
        year_id: 'Jahr',
        mode: 'Modus',
        transfer_status: 'Übermittlungsstatus',
        created_at: 'Uhrzeit',
    },

    association: 'Verband',
    year_id: 'Jahr',
    mode: 'Modus',
    transferred_statistic_processes: 'Übermittelte Statistikmeldungen IDs',

    showStatisticProcessTransfer: 'Übermittlung anzeigen',
}